export type NativePlatform = 'ios' | 'android'

/**
 * Store URLs opened from the force-update modal.
 */
export const APP_STORE_URLS: Record<NativePlatform, string> = {
  ios: 'https://apps.apple.com/be/app/my-bolt-b%C3%A8taversie/id6739292327',
  android: 'https://play.google.com/store/apps/details?id=be.boltenergie.mybolt'
}
